import { Observable, combineLatest, map } from 'rxjs';
import {
  EnhancedScopeData,
  ContextSort,
  NumericSortOrder,
  ContextShape,
} from '@ardoq/data-model';
import { Locale } from '@ardoq/locale';
import { workspaceUtils } from '@ardoq/scope-data';
import { getNavigatorViewInterfaceNoDnD } from './streams/getNavigatorViewInterfaceNoDnD';
import { ComponentHierarchyState } from '../componentHierarchyTypes';

type GetEnhancedScopeDataToHierarchyStreamArgs = {
  enhancedScopeData$: Observable<EnhancedScopeData>;
  locale: Locale;
  isStrictSelection?: boolean;
};

export const enhancedScopeDataToHierarchyStreamNoDnD = ({
  enhancedScopeData$,
  locale,
  isStrictSelection = false,
}: GetEnhancedScopeDataToHierarchyStreamArgs): Observable<ComponentHierarchyState> =>
  combineLatest({
    enhancedScopeData: enhancedScopeData$,
  }).pipe(
    map(({ enhancedScopeData }) => {
      // For now hardcode sort order, later we might want to make this
      // configurable.
      const sortOrder: ContextSort = {
        name: 'Name',
        attr: 'name',
        order: NumericSortOrder.ASC,
      };
      const navigatorInterface = getNavigatorViewInterfaceNoDnD(
        enhancedScopeData,
        sortOrder,
        locale,
        isStrictSelection
      );
      const workspaceIds = workspaceUtils.getAllWorkspaceIds(enhancedScopeData);
      const context: ContextShape = {
        workspaceIds,
        workspaceId: '',
        componentId: '',
        referenceId: '',
        scenarioId: '',
        presentationId: '',
        isExploreMode: false,
        sort: sortOrder,
      };
      const externalFilter = (id: string) =>
        enhancedScopeData.scopeComponentIds.has(id);

      return {
        navigatorInterface,
        context,
        enhancedScopeData,
        externalFilter,
      };
    })
  );
